<script>
  export default {
    name: 'app'
    , components: {
      headerComponent: () => import('@/components/user/HeadingUser.vue')
      , menuComponent: () => import('@/components/layouts/MainBarMenu.vue')
      , titleComponent: () => import('@/components/common/header/HeaderV2.vue')
    }
    , props : {
      headerTitle: String
      , headerSubTitle: {
          type: String
          , required: false
          , default: () => null
      }
      , showLocation: {
        type: Boolean
        , required: false
        , default: () => true
      }
    }
  }
</script>

<template>
  <div class="d-flex">
    <menu-component/>

    <b-container fluid>
      <b-row>
        <b-col cols="12">
          <header-component/>
        </b-col>

        <b-col cols="12">
          <title-component :title="headerTitle"
                           :subTitle="headerSubTitle"
                           :showLocation="showLocation"/>

          <b-container fluid>
            <slot name="container">
            </slot>
          </b-container>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<style scoped lang="scss">

</style>